var am4AnimatedBarChart = require('./animated-bar-chart');
var am4ColorThemes = require('./color-themes');
var am4Legend = require('./components/legend');
var am4ZoomButton = require('./components/zoomButton');
var am4Helpers = require('./helpers');

function setHighlightedColumnColor(highlightedCategories, color, columns) {
	columns.template.strokeOpacity = 0;
	columns.template.adapter.add('fill', function (fill, target) {
		if (target.dataItem.categoryX === undefined) {
			return fill;
		}

		if (highlightedCategories.indexOf(target.dataItem.categoryX.toLowerCase()) !== -1) {
			return color;
		}

		return fill;
	});
}

function getSeriesType(seriesType) {
	switch (seriesType) {
		case 'StepLine':
			return new window.am4charts.StepLineSeries();
		case 'Bar':
			return new window.am4charts.ColumnSeries();
		case 'BarStacked':
			return new window.am4charts.ColumnSeries();
		case 'BarHorizontal':
			return new window.am4charts.ColumnSeries();
		case 'BarOverlayed':
			return new window.am4charts.ColumnSeries();
		default:
			return new window.am4charts.LineSeries();
	}
}

function addBullet(series) {
	var bullet = series.bullets.push(new window.am4charts.CircleBullet());
	bullet.circle.strokeWidth = 2;
	bullet.circle.radius = 4;
	bullet.circle.fill = window.am4core.color('#fff');
	var bulletHover = bullet.states.create('hover');
	bulletHover.properties.scale = 1.3;

	//Skip over tabbing for line series
	series.skipFocusThreshold = 1;
}

function applyZIndex(series, chartType, seriesTypeName, index) {
	if (chartType === 'Prognosis') {
		series.zIndex = -index;
	} else if ((chartType === 'Combination' || chartType === 'LineDoubleAxes') && seriesTypeName === 'Line') {
		series.zIndex = index + 10;
	}
}

//Decides if labels on x-axis will fit or if they need to be rotated
var handleResponsiveCategoryLabels = function (categoryAxis) {
	var label = categoryAxis.renderer.labels.template;
	var lableMaxWidth = 85;

	categoryAxis.events.on('sizechanged', function (ev) {
		var axis = ev.target;
		var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
		axis.renderer.labels.template.maxWidth = cellWidth;

		if (cellWidth < lableMaxWidth) {
			axis.renderer.labels.template.rotation = 315;
			axis.renderer.labels.template.verticalCenter = 'middle';
			axis.renderer.labels.template.horizontalCenter = 'right';
			label.wrap = false;
		} else {
			axis.renderer.labels.template.rotation = 0;
			axis.renderer.labels.template.horizontalCenter = 'middle';
			label.wrap = true;
		}
	});
};

var showValueAxisLabel = function (valueAxis, label, chartType) {
	if (chartType === 'BarHorizontal') {
		valueAxis.title.text = label.replace('|', '\n');
		valueAxis.title.rotation = 0;
		valueAxis.title.align = 'right';
		valueAxis.title.valign = 'bottom';
		valueAxis.title.dx = 7;
	} else {
		valueAxis.renderer.grid.template.disabled = false;
		valueAxis.paddingLeft = 10;
		valueAxis.paddingRight = 10;
		valueAxis.layout = 'absolute';
		valueAxis.title.text = label.replace('|', '\n');
		valueAxis.title.rotation = 0;
		valueAxis.title.align = 'center';
		valueAxis.title.valign = 'top';
		valueAxis.title.dy = -40;
		valueAxis.title.dx = 13;
		valueAxis.title.isMeasured = false;
	}
};

var applyStyle = function (series) {
	series.strokeWidth = 2;
	series.minBulletDistance = 15;
	series.minBulletDistance = 30;
	series.connect = false;
	series.autoGapCount = 10000;
};

/*jshint maxcomplexity:false */
/*jshint maxstatements:100*/
/*jshint maxparams: 15 */
function createSeries(
	chart,
	seriesData,
	highlightedCategories,
	index,
	chartType,
	yAxisUnit,
	secondaryYAxisUnit,
	seriesName,
	yAxisSecondary,
	showDoubleYAxis
) {
	var isSecondaryYAxis = index === 1;
	var seriesTypeName = seriesData.Type;
	var series = chart.series.push(getSeriesType(seriesTypeName));
	series.dataFields.valueY = seriesName;
	series.dataFields.dateX = seriesData.XAxisName;
	series.dataFields.categoryX = seriesData.XAxisName;
	series.legendSettings.labelText = seriesData.Label;

	applyStyle(series);

	var isRangeSeries = seriesData.SubType === 'range';
	var isStacked = chartType === 'BarStacked';
	var isOverlayed = chartType === 'BarOverlayed';
	if (isRangeSeries) {
		series.dataFields.valueY = seriesName + 'ValueTop';
		series.dataFields.openValueY = seriesName + 'ValueBottom';
		series.sequencedInterpolation = true;
		series.fillOpacity = 1;
	} else if (isStacked) {
		series.tooltipText = '[bold]' + seriesName + '[/]' + ': {valueY.value} ' + yAxisUnit;
		series.tooltip.exportable = false;
		series.stacked = true;
	} else if (isOverlayed) {
		series.tooltipText = seriesName + ': {valueY.value} ' + yAxisUnit;
		series.tooltip.exportable = false;
	} else {
		series.tooltipText = ' {valueY.value} ' + yAxisUnit;
		series.tooltip.exportable = false;
	}

	if (!isRangeSeries && (
		seriesTypeName === 'Line' ||
		seriesTypeName === 'LineDoubleAxes' ||
		seriesTypeName === 'StepLine'
	)
	) {
		addBullet(series);
	}

	applyZIndex(series, chartType, seriesTypeName, index);

	if (seriesData.SubType === 'dashed') {
		series.strokeDasharray = 3;
	}

	if (showDoubleYAxis === true && isSecondaryYAxis) {
		series.yAxis = yAxisSecondary;
		series.tooltipText = '{valueY.value} ' + secondaryYAxisUnit;
	}

	if (series.columns) {
		series.itemReaderText = '{category} ' + seriesName + ' : {valueY.value} ' + yAxisUnit;
		series.columns.template.hoverOnFocus = true;
		series.columns.template.tooltipText = '{valueY.value} ' + yAxisUnit;

		if (highlightedCategories.length > 0) {
			setHighlightedColumnColor(highlightedCategories.toString(), chart.colors.list[1], series.columns);
		}
	}

	if (chartType === 'BarHorizontal') {
		series.dataFields.valueX = seriesName;
		series.dataFields.dateY = seriesData.XAxisName;
		series.dataFields.categoryY = seriesData.XAxisName;
		series.tooltipText = '{valueX.value} ' + yAxisUnit;
		series.itemReaderText = '{category} ' + seriesName + ' : {valueX.value} ' + yAxisUnit;
		series.columns.template.tooltipText = '{valueX.value} ' + yAxisUnit;
	}

	if (isStacked) {
		series.columns.template.strokeWidth = 1;
		series.columns.template.stroke = window.am4core.color('#ffffff');
		series.columns.template.strokeOpacity = 1;
	}

	if (chartType === 'BarOverlayed') {
		series.clustered = false;

		if (index === 0) {
			series.fill = chart.colors.list[0];
			series.tooltip.pointerOrientation = 'down';
			series.columns.template.tooltipY = 0;
			series.tooltip.dy = -5;
		}

		if (index === 1) {
			series.columns.template.adapter.add('fill', function (fill, target) {
				var pattern = new window.am4core.Pattern();
				var image = new window.am4core.Image();
				/*jshint maxlen: 2000 */
				image.href = 'data:image/svg+xml;charset=utf-8;base64,PHN2ZyBpZD0iZWcxdjBtSUV4Y3AxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgc2hhcGUtcmVuZGVyaW5nPSJnZW9tZXRyaWNQcmVjaXNpb24iIHRleHQtcmVuZGVyaW5nPSJnZW9tZXRyaWNQcmVjaXNpb24iIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48cmVjdCBpZD0iZWcxdjBtSUV4Y3AyIiB3aWR0aD0iNzMuNzY5Mzg5IiBoZWlnaHQ9IjY3LjcwODQ3NCIgcng9IjAiIHJ5PSIwIiB0cmFuc2Zvcm09Im1hdHJpeCg2LjMyMjQwNiAtNi4zMjI0MDYgMC41MjIxNyAwLjUyMjE3IC0zNjEuOTQyNTE5IDQ0MS43NjAwODYpIiBmaWxsPSJyZ2IoMCwxMTMsMTg1KSIgc3Ryb2tlPSJyZ2IoMCwxMTMsMTg1KSIgc3Ryb2tlLXdpZHRoPSIxIi8+PHJlY3QgaWQ9ImVnMXYwbUlFeGNwMyIgd2lkdGg9IjczLjc2OTM4OSIgaGVpZ2h0PSI2Ny43MDg0NzQiIHJ4PSIwIiByeT0iMCIgdHJhbnNmb3JtPSJtYXRyaXgoNi4zMjI0MDYgLTYuMzIyNDA2IDAuNTIyMTcgMC41MjIxNyAtNDExLjk0MjUxOSAzOTEuNzYwMDg2KSIgZmlsbD0icmdiKDAsMTEzLDE4NSkiIHN0cm9rZT0icmdiKDAsMTEzLDE4NSkiIHN0cm9rZS13aWR0aD0iMSIvPjxyZWN0IGlkPSJlZzF2MG1JRXhjcDQiIHdpZHRoPSI3My43NjkzODkiIGhlaWdodD0iMjcuMDgzMzkiIHJ4PSIwIiByeT0iMCIgdHJhbnNmb3JtPSJtYXRyaXgoNi4zMjI0MDYgLTYuMzIyNDA2IDAuNTIyMTcgMC41MjIxNyAtMzQwLjk0MjUxOSAzOTEuNzYwMDg2KSIgZmlsbD0icmdiKDI1NSwyNTUsMjU1KSIgc3Ryb2tlPSJyZ2IoMCwxMTMsMTg1KSIgc3Ryb2tlLXdpZHRoPSIxIi8+PHJlY3QgaWQ9ImVnMXYwbUlFeGNwNSIgd2lkdGg9IjczLjc2OTM4OSIgaGVpZ2h0PSIyNy4wODMzOSIgcng9IjAiIHJ5PSIwIiB0cmFuc2Zvcm09Im1hdHJpeCg2LjMyMjQwNiAtNi4zMjI0MDYgMC41MjIxNyAwLjUyMjE3IC0yNDAuOTQyNTE5IDM5MS43NjAwODYpIiBmaWxsPSJyZ2IoMjU1LDI1NSwyNTUpIiBzdHJva2U9InJnYigwLDExMywxODUpIiBzdHJva2Utd2lkdGg9IjEiLz48cmVjdCBpZD0iZWcxdjBtSUV4Y3A2IiB3aWR0aD0iNzMuNzY5Mzg5IiBoZWlnaHQ9IjM4LjE1NjYyMSIgcng9IjAiIHJ5PSIwIiB0cmFuc2Zvcm09Im1hdHJpeCg2LjMyMjQwNiAtNi4zMjI0MDYgMC41MjIxNyAwLjUyMjE3IC0zMTEuOTQyNTE5IDQ5MS43NjAwODYpIiBmaWxsPSJyZ2IoMCwxMTMsMTg1KSIgc3Ryb2tlPSJyZ2IoMCwxMTMsMTg1KSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9zdmc+';
				image.width = 10;
				image.height = 10;
				pattern.addElement(image.element);
				return pattern;
			});

			series.tooltip.getFillFromObject = false;
			series.tooltip.background.fill = window.am4core.color('#fff');
			series.tooltip.background.stroke = chart.colors.list[0];
			series.tooltip.label.fill = window.am4core.color('#000');
		}
	}
}

function createXAxis(chart, chartType, xAxisLabel, xAxisTooltipDateFormat, valueAxisLabel) {
	var xAxis;
	var breakpoint;

	if (
		chartType === 'Bar' ||
		chartType === 'BarStacked' ||
		chartType === 'BarOverlayed' ||
		chartType === 'Combination' ||
		chartType === 'LineDoubleAxes'
	) {
		xAxis = chart.xAxes.push(new window.am4charts.CategoryAxis());
		xAxis.dataFields.category = xAxisLabel;
		xAxis.renderer.grid.template.location = 0;
		xAxis.renderer.minGridDistance = chart.data.length > 25 ? 40 : 15;
		xAxis.renderer.cellStartLocation = 0.2;
		xAxis.renderer.cellEndLocation = 0.8;
		handleResponsiveCategoryLabels(xAxis);
		if (chartType === 'BarOverlayed') {
			xAxis.tooltip.disabled = true;
		}
	} else if (chartType === 'BarHorizontal') {
		xAxis = chart.xAxes.push(new window.am4charts.ValueAxis());
		xAxis.tooltip.disabled = true;
		xAxis.renderer.minGridDistance = 60;
		am4Helpers.setValueAxisMinimum(chart, xAxis);
		showValueAxisLabel(xAxis, valueAxisLabel, chartType);
		return xAxis;
	} else if (chartType === 'Composite') {
		xAxis = chart.xAxes.push(new window.am4charts.DateAxis());
		breakpoint = chart.data.filter((value) => value[Object.getOwnPropertyNames(value)[1]])
			.sort(((val1, val2) => val2[Object.getOwnPropertyNames(val2)[0]]
				.localeCompare(val1[Object.getOwnPropertyNames(val1)[0]])))[0][Object.getOwnPropertyNames(chart.data[0])[0]];
		xAxis.adapter.add("getTooltipText", function (text, target) {
			let tooltipDateMilliseconds = target.tooltipDate.getTime();
			let breakpointMilliseconds = new Date(breakpoint).getTime();
			if (target.tooltipDate && tooltipDateMilliseconds >= breakpointMilliseconds) {
				return chart.dateFormatter.format(target.tooltipDate, "'Q'q yyyy");
			}
			return text;
		});
	} else {
		xAxis = chart.xAxes.push(new window.am4charts.DateAxis());
		xAxis.tooltipDateFormat = xAxisTooltipDateFormat;
		xAxis.baseInterval = {
			timeUnit: 'day',
			count: 1
		};
	}

	// Make a panning cursor
	chart.cursor = new window.am4charts.XYCursor();
	chart.cursor.behavior = 'panXY';
	chart.cursor.xAxis = xAxis;
	chart.cursor.exportable = false;

	return xAxis;
}

function createYAxis(chart, chartType, yAxisLabel, valueAxisLabel, showDoubleYAxis, isSecondaryYAxis) {
	var yAxis;
	if (chartType === 'BarHorizontal') {
		yAxis = chart.yAxes.push(new window.am4charts.CategoryAxis());
		yAxis.dataFields.category = yAxisLabel;
		yAxis.renderer.inversed = true; //Temp
		yAxis.renderer.grid.template.location = 0;
		yAxis.renderer.minGridDistance = 10;
		yAxis.renderer.cellStartLocation = 0.2;
		yAxis.renderer.cellEndLocation = 0.8;
		chart.cursor = new window.am4charts.XYCursor();
		chart.cursor.behavior = 'panXY';
		chart.cursor.yAxis = yAxis;
		chart.cursor.exportable = false;
		var label = yAxis.renderer.labels.template;
		label.truncate = true;
		label.maxWidth = 120;
	} else {
		yAxis = chart.yAxes.push(new window.am4charts.ValueAxis());
		yAxis.tooltip.disabled = true;
		showValueAxisLabel(yAxis, valueAxisLabel);
	}

	if (chartType === 'Bar' || chartType === 'BarStacked' || chartType === 'BarOverlayed') {
		am4Helpers.setValueAxisMinimum(chart, yAxis);
	}

	if (showDoubleYAxis === true && isSecondaryYAxis === false) {
		yAxis.renderer.line.stroke = chart.colors.list[0];
		yAxis.title.fill = chart.colors.list[0];
		yAxis.title.fontWeight = 600;
	}

	if (isSecondaryYAxis === true) {
		yAxis.renderer.opposite = true;
		yAxis.renderer.grid.template.disabled = true;
		yAxis.title.rotation = 0;
		yAxis.x = 25;
		yAxis.title.fill = chart.colors.list[1];
		yAxis.title.fontWeight = 600;
	}

	return yAxis;
}

module.exports = {
	createXYChart: function ($graphblock, data) {
		/*jshint maxcomplexity:false */
		var chartType = $graphblock.data('charttype');
		var hasYearData = $graphblock.data('chartdata').End;
		var chart = window.am4core.create($graphblock.attr('id'), window.am4charts.XYChart);
		var seriesData = $graphblock.data('chartdata').Series;
		var highlightedCategories = $graphblock.data('highlightedcategories').toLowerCase().split(';');
		var xAxisTooltipDateFormat = $graphblock.data('xaxisdateformat');
		var yAxisUnit = $graphblock.data('yaxisunit');
		var secondaryYAxisUnit = $graphblock.data('secondaryyaxisunit');
		var valueAxisLabel = $graphblock.data('yaxislabel');
		var hideLegend = $graphblock.data('hidelegend').toLowerCase() === 'true';

		var showDoubleYAxis = chartType === 'LineDoubleAxes';
		var yAxisSecondary;
		var isSecondaryYAxis;
		chart.data = data;

		chart.colors.list = am4ColorThemes.getChartColorTheme($graphblock.data('charttype'));

		const newColorList = [];
		const RequestActualColorIdsMap = new Map();
		const avalableColors = chart.colors.list.length;
		let nextColor = 0;

		for (let i = 0; i < seriesData.length; i++) {
			const series = seriesData[i];

			if (series.ColorId === null) {
				newColorList.push(chart.colors.list[nextColor % avalableColors]);
				nextColor++;
			} else if (!RequestActualColorIdsMap.has(series.ColorId)) {
				RequestActualColorIdsMap.set(series.ColorId, nextColor);
				newColorList.push(chart.colors.list[nextColor % avalableColors]);
				nextColor++;
			} else {
				const id = RequestActualColorIdsMap.get(series.ColorId);
				newColorList.push(chart.colors.list[id]);
			}
		}

		chart.colors.list = newColorList;

		chart.paddingTop = 40;

		am4ZoomButton.createZoomButton(chart);

		//Add legend (optional but default)
		if (seriesData.length > 1 && !hideLegend) {
			am4Legend.createLegend(chart);
		}

		//Add scrollbar (optional)
		if ($graphblock.data('showscrollbarx').toLowerCase() === 'true') {
			chart.scrollbarX = new window.am4core.Scrollbar();
			chart.scrollbarX.parent = chart.bottomAxesContainer;
			chart.scrollbarX.exportable = false;
			chart.scrollbarX.position = 'bottom';
		}

		chart.focusFilter.stroke = window.am4core.color('#f59a00');
		chart.focusFilter.strokeWidth = 6;

		//Create Y-axis
		createYAxis(
			chart,
			chartType,
			seriesData[0].XAxisName,
			valueAxisLabel,
			showDoubleYAxis,
			isSecondaryYAxis = false
		);

		//Create X-axis
		var xAxis = createXAxis(chart,
			chartType,
			seriesData[0].XAxisName,
			xAxisTooltipDateFormat,
			valueAxisLabel
		);

		//Create secondary Y-axis (optional)
		if (showDoubleYAxis === true) {
			yAxisSecondary = createYAxis(
				chart,
				chartType,
				seriesData[1].XAxisName,
				$graphblock.data('secondaryyaxislabel'),
				showDoubleYAxis,
				isSecondaryYAxis = true
			);
		}

		// Create series for XYChart
		for (var i = 0; i < seriesData.length; i++) {
			var seriesName = seriesData[i].Name;
			if (hasYearData) {
				seriesName = seriesName + $graphblock.data('chartdata').Start;
			}
			createSeries(
				chart,
				seriesData[i],
				highlightedCategories,
				i,
				chartType,
				yAxisUnit,
				secondaryYAxisUnit,
				seriesName,
				yAxisSecondary,
				showDoubleYAxis
			);
		}

		if (hasYearData) {
			var yearData = {
				Start: parseInt($graphblock.data('chartdata').Start),
				End: parseInt($graphblock.data('chartdata').End)
			};
			am4AnimatedBarChart.createAnimatedBarChart(chart, seriesData, xAxis, yearData, $graphblock);
		}

		return chart;
	}
};
